export const WS_FS_DELETE_TELEMETRY_EVENT_NAME = 'WsFsDeletionReasonCaptured';
